import { render, staticRenderFns } from "./GateContent.vue?vue&type=template&id=8d12b736&"
import script from "./GateContent.vue?vue&type=script&lang=js&"
export * from "./GateContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports